export const uxDesignerPlatformAccess = {
  junior: {
    required: [
      'Figma team access',
      'Company Slack workspace',
      'Design system library',
      'Google Drive/Workspace',
      'Company email setup'
    ],
    optional: [
      'Adobe Creative Cloud',
      'Miro team boards',
      'Notion workspace'
    ],
    permissions: ['View design files', 'Comment on designs', 'Basic library access']
  },
  mid: {
    required: [
      'Figma admin access',
      'Design system edit rights',
      'User research platforms',
      'Analytics tools access',
      'Project management tools'
    ],
    optional: [
      'Prototyping tools',
      'Advanced research tools',
      'A/B testing platforms'
    ],
    permissions: ['Edit design files', 'Manage libraries', 'Create projects', 'User research access']
  },
  senior: {
    required: [
      'Figma organization admin',
      'Design system governance',
      'Strategic planning tools',
      'Executive dashboards',
      'Team management platforms'
    ],
    optional: [
      'Business intelligence tools',
      'Advanced analytics',
      'Strategic planning software'
    ],
    permissions: ['Full admin access', 'Team management', 'Strategic planning', 'Budget access']
  }
};
